import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Banner que se muestra solo en entorno de Preview/Desarrollo
 * para distinguirlo del entorno de Producción
 */
export default function PreviewBanner() {
  // Detectar si estamos en Preview o Producción
  // Preview usa URLs como: emt-xxxx-preview.emergentapps.ai o localhost
  // Producción usa el dominio personalizado: cirodelpacifico.com
  
  const isPreview = () => {
    const hostname = window.location.hostname;
    
    // Es Preview si:
    // - Es localhost
    // - Contiene "preview" en la URL
    // - Es una URL de emergentapps.ai (no es dominio personalizado)
    // - Contiene "emt-" (patrón de Emergent)
    
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return true;
    }
    
    if (hostname.includes('preview')) {
      return true;
    }
    
    if (hostname.includes('emergentapps.ai')) {
      return true;
    }
    
    if (hostname.includes('emt-')) {
      return true;
    }
    
    // Si es un dominio personalizado (como cirodelpacifico.com), es Producción
    return false;
  };

  // No mostrar nada en Producción
  if (!isPreview()) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2 sticky top-0 z-[100]">
      <AlertTriangle className="w-4 h-4" />
      <span>
        <strong>ENTORNO DE PRUEBAS</strong> — Los datos aquí no afectan la aplicación en producción
      </span>
      <AlertTriangle className="w-4 h-4" />
    </div>
  );
}
